let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kQ4bh")).then(() => parcelRequire('6At3v'));